import jwtDecode from "jwt-decode";
import { msalInstance } from "../App";
interface DecodedToken {
  roles?: string[];
  aud?: string;
  iss?: string;
  iat?: number;
  nbf?: number;
  exp?: number;
  name?: string;
  preferred_username?: string;
  [key: string]: any;
}

/**
 * Get user roles from MSAL ID token claims
 * Falls back to access token from localStorage if MSAL is not available
 */
export const getUserRoles = (): string[] => {
  try {
    // Try to get roles from MSAL ID token claims (preferred method)
    if (msalInstance) {
      const account = msalInstance.getActiveAccount();
      if (account?.idTokenClaims) {
        const claims = account.idTokenClaims as any;
        console.log("ID Token Claims:", claims); // Debug log
        // Roles can be in 'roles' or 'role' claim
        const roles = claims.roles || claims.role || [];
        const rolesArray = Array.isArray(roles) ? roles : [roles];
        console.log("Roles from ID token:", rolesArray); // Debug log
        return rolesArray;
      } else {
        console.log("No ID token claims available");
      }
    } else {
      console.log("MSAL instance not available");
    }

    // Fallback to decoding access token from localStorage
    const token = localStorage.getItem("accessToken");
    if (!token) {
      console.log("No access token in localStorage");
      return [];
    }

    const decoded: DecodedToken = jwtDecode(token);
    const roles = decoded.roles || [];
    console.log("Roles from access token:", roles); // Debug log
    return roles;
  } catch (error) {
    console.error("Error getting user roles:", error);
    return [];
  }
};

export const hasRole = (role: string): boolean => {
  const roles = getUserRoles();
  return roles.includes(role);
};

export const hasAnyRole = (allowedRoles: string[]): boolean => {
  const roles = getUserRoles();
  return allowedRoles.some((role) => roles.includes(role));
};
